<template>
	<FullModal ref="clientsModal">
		<template #head>
			<NavbarSearch :opened="true" @changed="searching" @closed="$refs.clientsModal.close()" />
		</template>

		<Loader :show="loading" type="inline" />

		<div class="list">
			<div class="item" v-for="(item, i) in searchResults" :key="i" @click="$refs.clientModal.open(item)">
				<div class="circle" :style="{ 'background-color': item.client.profileColor }">
					<i class="icon icon-man-people-streamline-user"></i>

					<div class="vip-badge" v-if="item.membership">VIP</div>
				</div>
				<div>
					<h3>{{ item.client.name }} {{ item.client.lastname }}</h3>
					<p>{{ item.client.document }}</p>
				</div>
			</div>
		</div>

		<div class="alert alert-dark text-center" v-if="!loading && clients.length == 0">
			El evento aun no tiene tickets o membresias habilitadas para ingresar
		</div>

		<ClientModal ref="clientModal" :eventId="eventId" />
	</FullModal>
</template>

<script>
import gql from "graphql-tag"
import Modal from "@/components/Modal"
import FullModal from "@/components/FullModal"
import NavbarSearch from "@/components/NavbarSearch"
import ClientModal from "./ClientModal"

export default {
	name: "EventEnabledClients",
	components: {
		Modal,
		FullModal,
		NavbarSearch,
		ClientModal
	},
	props: {
		eventId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			loading: false,
			clients: [],

			searchResults: []
		}
	},

	methods: {
		open() {
			this.searchResults = []
			this.load()
			this.$refs.clientsModal.open()
		},
		searching(term) {
			if (term) {
				this.searchResults = this.clients.filter((item) => {
					return term
						.toLowerCase()
						.split(" ")
						.every((v) => {
							return (
								item.client.name.toLowerCase().includes(v) ||
								item.client.lastname.toLowerCase().includes(v) ||
								item.client.document.toLowerCase().includes(v)
							)
						})
				})
			} else {
				this.searchResults = this.clients
			}
		},

		load() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							clientsByEvent(eventId: $id) {
								data {
									client {
										id
										name
										lastname
										document
										profileColor
									}
									ticket {
										id
										ticketType {
											id
											name
										}
									}
									membership {
										id
										membershipType {
											id
											name
										}
									}
									checkIn {
										id
										createdAt
									}
								}
							}
						}
					`,
					variables: {
						id: this.eventId
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.clients = data.clientsByEvent.data
					this.searchResults = this.clients
					this.loading = false
				})
				.catch((err) => {
					// this.$toast.error("Error al cargar la inspección")
				})
		}
	}
}
</script>

<style scoped lang="scss">
.list {
	.item {
		padding: 8px 12px;
		display: flex;
		align-items: center;

		&:hover {
			background-color: #2e2e2e;
		}

		.circle {
			width: 42px;
			height: 42px;
			border-radius: 24px;
			margin-right: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;

			.icon {
				width: 22px;
				height: 22px;
				font-size: 20px;
			}

			.vip-badge {
				display: block;
				display: block;
				font-size: 0.6rem;

				font-weight: 500;
				position: absolute;
				width: 34px;
				height: 17px;
				bottom: -10px;

				border-radius: 14px;
				background-color: #000;
				color: #fff;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		h3 {
			font-size: 1rem;
			color: #fff;
			font-weight: 500;
		}
		p {
			font-size: 0.8rem;
			color: #fff;
			line-height: 0.8rem;
			margin: 0px;
		}
	}
}
</style>
